"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataStore = (function () {
    function DataStore(json) {
        this.json = json;
    }
    DataStore.prototype.getAllStates = function () {
        var states = this.json.states;
        return states.map(function (s) {
            return { value: s.name, name: s.name };
        });
    };
    DataStore.prototype.getAdvisorsArray = function (campusName) {
        var json = this.json;
        if (json.campuses) {
            for (var i = 0; i < json.campuses.length; i++) {
                if (json.campuses[i].name == campusName) {
                    return json.campuses[i].advisors;
                }
            }
        }
        console.log("Warning! No advisers found for campus=" + campusName);
        return null;
    };
    Object.defineProperty(DataStore.prototype, "programs", {
        get: function () {
            var json = this.json;
            var programs = [];
            if (json.programs) {
                programs = json.programs;
                programs.sort(function (a, b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
            }
            return programs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "campuses", {
        get: function () {
            var json = this.json;
            var campuses = [];
            if (json.campuses) {
                campuses = json.campuses;
                campuses.sort(function (a, b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
            }
            return campuses;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "marital_status", {
        get: function () {
            return [
                { value: "Married", name: "Married" },
                { value: "Single", name: "Single" },
                { value: "Divorced", name: "Divorced" },
                { value: "Widow", name: "Widow" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "gender", {
        get: function () {
            return [
                { value: "Male", name: "Male" },
                { value: "Female", name: "Female" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "methodOfContact", {
        get: function () {
            return [
                { name: "Phone", value: "Phone" },
                { name: "Email", value: "Email" },
                { name: "Text", value: "SMS" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "agreeList", {
        get: function () {
            return [
                { id: 1, value: "I understand & agree", name: "I understand & agree", checked: false }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "enrollment_status", {
        get: function () {
            return [
                { value: "full_time", name: "Full Time" },
                { value: "half_time_1", name: "Part Time Day" },
                { value: "half_time_2", name: "Part Time Night" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "interestedInStarting", {
        get: function () {
            return [
                { value: "As soon as posible", name: "As soon as possible" },
                { value: "1 Month", name: "1 Month" },
                { value: "2 Month", name: "2 Month" },
                { value: "3 Month", name: "3 Month" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "interestedInStartingMonths", {
        get: function () {
            return [
                { value: "january", name: "January" },
                { value: "february", name: "February" },
                { value: "march", name: "March" },
                { value: "april", name: "April" },
                { value: "may", name: "May" },
                { value: "june", name: "June" },
                { value: "july", name: "July" },
                { value: "august", name: "August" },
                { value: "september", name: "September" },
                { value: "october", name: "October" },
                { value: "november", name: "November" },
                { value: "december", name: "December" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "programOptions", {
        get: function () {
            return [
                { name: "Barber Stylist", value: "Barber Stylist" },
                { name: "Cosmo Crossover", value: "Cosmo Crossover" },
                {
                    name: "Barber Stylist Instructor Training",
                    value: "Barber Stylist Instructor Training"
                }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "militaryStatuses", {
        get: function () {
            return [
                { value: "active_duty", name: "Active Military" },
                { value: "not_veteran", name: "Not a Veteran" },
                { value: "veteran", name: "Veteran" },
                { value: "spouse", name: "Spouse or Surviving Spouse" },
                { value: "drilling_guard", name: "Drilling Guard or Reservist" },
                { value: "child_dependent", name: "Child or Dependent" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "programsQualificationInterest", {
        get: function () {
            return [
                {
                    id: 1,
                    value: "SC Vocational Rehabilitation",
                    name: "SC Vocational Rehabilitation",
                    checked: false
                },
                { id: 2, value: "SC Works", name: "SC Works", checked: false },
                { id: 3, value: "N/A", name: "N/A", checked: false }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "currentEmploymentSituation", {
        get: function () {
            return [
                {
                    value: "currently_unemployed_and_actively_looking_for_a_job",
                    name: "I am currently unemployed and actively looking for a job"
                },
                {
                    value: "currently_unemployed_and_not_actively_looking_for_a_job",
                    name: "I am currently unemployed and not actively looking for a job"
                },
                {
                    value: "currently_employed_and_seeking_career_advancement",
                    name: "I am currently employed and seeking career advancement"
                },
                {
                    value: "currently_employed_and_not_seeking_career_advancement",
                    name: "I am currently employed and not seeking career advancement"
                },
                { value: "other", name: "Other" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    return DataStore;
}());
exports.DataStore = DataStore;
//# sourceMappingURL=data:application/json;base64,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